import { TableCell } from '@mui/material';
import * as React from 'react';

interface Props {
    summaryData?: { [key: string]: any };
    summaryFieldKey: string;
    cellId: number;
}

export const InitTableCellFooter: React.FC<Props> = (props: Props) => {
    const { summaryData, summaryFieldKey } = props;
    let { cellId } = props;
    return (
        <TableCell key={++cellId}>
            {summaryFieldKey && summaryData?.hasOwnProperty(summaryFieldKey)
                ? summaryData[summaryFieldKey]
                : ''}
        </TableCell>
    );
};
